
const tabs = [
  { href: '/', label: 'Home', iconClass: 'prs-icon-home' },
  {
    href: '/myworks', label: 'My works', iconClass: 'prs-icon-my-works', access: 'isSodUser',
  },
  {
    href: '/search', label: 'Works', iconClass: 'prs-icon-search', access: 'isSodUser',
  },
  { href: '/schedule', label: 'Payment dates', iconClass: 'prs-icon-calendar' },
];


const { statements, setListHub } = window.mobile.config.urls;
const { olsEnabled, slhEnabled } = window.mobile.userOptions;
const { homepageLinksEnabled } = window.mobile.features;

if (homepageLinksEnabled && olsEnabled) {
  tabs.push({ href: `'${statements}'`, label: 'My statements', iconClass: 'prs-icon-statements' });
}

if (homepageLinksEnabled && slhEnabled) {
  tabs.push({ href: `'${setListHub}'`, label: 'Report performance', iconClass: 'prs-icon-setlisthub' });
}

export default tabs;
